<section class="desk:centered-with-padding pb-7">
  <div class="h-[262px] overflow-hidden rounded-b-[20px] desk:h-[459px]">
    <app-image [image]="data.image" [isPriority]="!isImageInPreviousBlocks" [pregenerationSize]="{ width: 1920 }" />
  </div>
</section>
